import React from "react";
import PdfPage from "../components/PdfPage";
import "./index.css";
import policyImg from "../assets/images/policy.jpg";
const Policies = () => {
  return (
    <main className="pdf-modern-page">
      <PdfPage
        h1={"Policies & Procedures"}
        // h2={"KNOW YOUR CUSTOMER & CUSTOMER DUE DILIGENCE"}
        img={policyImg}
        pdf1={"/img/ANTI-MONEY-LAUNDERING-COMPLIANCE-POLICY-2023.pdf"}
        pdf1Text={"Compliance Policy"}
        pdf2={
          "/img/ONLINE TRADING POLICY  WITH TERMS AND CONDITIONS FOR ONLINE 2023-2024.pdf"
        }
        pdf2Text={"Online Trading Policy"}
      />
      <PdfPage
        // h1={"Policies & Procedures"}
        // h2={"Risk Management Policy"}
        img={policyImg}
        pdf1={"/img//RISK MANAGEMENT POLICY 2023-2024.pdf"}
        pdf1Text={"Compliance Policy"}
        pdf2={"/img/ONLINE TRADING RISK ENGLISH & URDU 2023-2024.pdf"}
        pdf2Text={"Online Trading Risk Policy"}
      />
    </main>
  );
};

export default Policies;
